import React from "react";
import classNames from "classnames";
import ItineraryIcon from "../stop-finder/ItineraryIcon";
import { useWindowScroll } from "react-use";

function ItineraryPrimaryHeader(props) {
    const { setIsOpenItinerarySwitcher, showCloseBtn, hideShadow, showItinerarySwitcher } = props;
    const { y } = useWindowScroll();
    const closeIframeModal = () => {
        if (!window.parent) {
            return;
        }
        window.parent.postMessage("CLOSE_MODAL", "*");
    };

    return (
        <div
            className={classNames("trpr-itinerary-primary-header", {
                "is-fixed": y > 0,
                "hide-shadow": hideShadow,
            })}
        >
            {showItinerarySwitcher && (
                <div>
                    <button
                        onClick={() => setIsOpenItinerarySwitcher(true)}
                        type="button"
                        className="trpr-itinerary-switcher-popup__header-close"
                    >
                        <ItineraryIcon></ItineraryIcon>
                    </button>
                </div>
            )}
            {showCloseBtn && (
                <div>
                    <button
                        onClick={closeIframeModal}
                        type="button"
                        className="trpr-itinerary-switcher-popup__header-close"
                    >
                        <i className="trpr__icon-close"></i>
                    </button>
                </div>
            )}
        </div>
    );
}

export default ItineraryPrimaryHeader;
